import { render, staticRenderFns } from "./PrimaryInsurance.vue?vue&type=template&id=1aed0a3e&scoped=true&"
import script from "./PrimaryInsurance.vue?vue&type=script&lang=js&"
export * from "./PrimaryInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryInsurance.vue?vue&type=style&index=0&id=1aed0a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed0a3e",
  null
  
)

export default component.exports